import { Component, Input } from "@angular/core";
import { NavButton } from "./next-button.component";

@Component({
  selector: "app-screen-header",
  template: `
    <div class="row m-screen-header">
      <div class="col">
        <div class="m-screen-header-wrapper" [ngClass]="buttonInfo.cssClass">
          <em class="fa fa-angle-left" aria-hidden="true" [routerLink]="buttonInfo.routeUrl"></em>
          <div class="header-title">
            <div class="screenNumber">
              <span class="number">{{ buttonInfo.number }}</span>
            </div>
            {{ buttonInfo.buttonText }}
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [],
})
export class ScreenHeaderComponent {
  @Input() buttonInfo: NavButton = {
    buttonText: "Text Button",
    routeUrl: "/m/main",
    cssClass: "my-class",
    number: 1,
  };
}
